import { useEffect, useRef } from 'react';
import { useSearchParams } from 'react-router-dom';
import { parseFiltersFromQs, type TFilterSchema } from 'shared/utils/filters/parse-filters-from-qs';

interface IInitFiltersFromUrlParams<T> {
  schema: TFilterSchema<T>;
  setFilters: (filters: T | undefined) => void;
}

export const useInitFiltersFromUrl = <T extends object>(args: IInitFiltersFromUrlParams<T>) => {
  const { schema, setFilters } = args;
  const [searchParams] = useSearchParams();
  const isApplied = useRef(false);

  useEffect(() => {
    if (isApplied.current) return;

    isApplied.current = true;

    const filtersFromUrl = parseFiltersFromQs<T>(searchParams, schema);

    if (filtersFromUrl) setFilters(filtersFromUrl);
  }, []);
};
